import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocaleService } from '@app/locale.service';

@Component({
  selector: 'app-locale-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      class="btn btn-transparent btn-icon btn-icon-only"
      (click)="selectLocale()"
      aria-label="Locale"
    >
      <span style="width: 22px; height: 22px">
        <ng-container *ngIf="transparent">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Group 1252">
              <path
                id="Vector"
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M1 12H23"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_3"
                d="M12.0001 1C14.7515 4.01219 16.3151 7.92124 16.4001 12C16.3151 16.0788 14.7515 19.9878 12.0001 23C9.24869 19.9878 7.68507 16.0788 7.6001 12C7.68507 7.92124 9.24869 4.01219 12.0001 1Z"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </ng-container>
        <ng-container *ngIf="!transparent">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Group 1252">
              <path
                id="Vector"
                d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
                stroke="#2E2E51"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_2"
                d="M1 12H23"
                stroke="#2E2E51"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                id="Vector_3"
                d="M11.9996 1C14.751 4.01219 16.3146 7.92124 16.3996 12C16.3146 16.0788 14.751 19.9878 11.9996 23C9.2482 19.9878 7.68458 16.0788 7.59961 12C7.68458 7.92124 9.2482 4.01219 11.9996 1Z"
                stroke="#2E2E51"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        </ng-container>
      </span>
    </button>
  `,
  styles: [
    `
      :host {
        display: block;
      }

      .btn {
        display: inline-flex;
        padding: var(--spacing-sm, 12px) var(--spacing-lg, 24px);
        justify-content: center;
        align-items: center;
        gap: var(--spacing-xs, 8px);
        border-radius: var(--spacing-xs, 8px);
        font-family: Red Hat Display;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.15px;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
      }

      .btn-transparent {
        background: transparent;
        color: var(--brand-primary-text, #2e2e51);
        border: none;
      }

      .btn-icon {
        display: inline-flex;
        align-items: center;
        gap: var(--spacing-xs, 8px);
      }

      .btn-icon-only {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        min-width: auto;
        background: transparent;
        border: none;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      :host-context(.transparent) {
        .btn-transparent {
          color: white;
        }
      }
    `,
  ],
})
export class LocaleButtonComponent {
  @Input() transparent = false;

  constructor(private localeService: LocaleService) {}

  selectLocale() {
    this.localeService.showLocaleModal();
  }
}
